import React from "react";
import { Link } from "react-router-dom";

const Calltoaction = () => {
  return (
    <div className="h-auto w-full bg-[radial-gradient(148.99%_1253.88%_at_140.91%_-26.77%,#07031C_2.02%,#07031C_35.82%,#07031C_52.69%,#241D49_81.58%)] grid place-items-center py-10 md:h-[435px]">
      
      <div className="  w-[70%] grid place-content-center place-items-center">


      <p
        className="text-center text-[24px] md:text-[42px] font-lato font-normal leading-[100%] tracking-[0px] text-[#D4F5F9]"
       
      >
        Stay ahead and immerse yourself in a world <br/> of cutting-edge crypto information
      </p>

  

      <Link
        to="/signup"
        className="w-[150px] md:w-[200px] flex mt-6 md:mt-[50px] bg-[#E8EEF1] bg-opacity-90 shadow-md h-[45px] rounded-lg justify-center items-center px-4 md:px-14"
      >
        <p className="font-istok text-[#00001A] text-[16px]">Get Started</p>
      </Link>
            </div>
    </div>
  );
};

export default Calltoaction;
